import {useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import {getProjectInfo, getProjectServices} from '../../actions/projectActions';
import {getOrganizationQuotaUtilization, getProjectQuotaLimits} from '../../actions/quotaActions';
import {useProject, useSelectedProjectId} from '../../hooks/selectors';
import {useDashboardApi} from '../../hooks/use-api';

function ProjectWrapper() {
  const projectId = useSelectedProjectId();
  const organizationId = useProject(projectId || '')?.organization_id;
  const {setQueryData: setProjectQueryData} = useDashboardApi<{projectId: string}>();
  useEffect(() => {
    if (projectId) {
      setProjectQueryData({
        action: getProjectInfo,
        data: {projectId},
      });
    }
  }, [projectId, setProjectQueryData]);

  const {setQueryData: setServicesQueryData} = useDashboardApi<{
    projectId: string;
  }>();
  useEffect(() => {
    if (projectId) {
      setServicesQueryData({
        action: getProjectServices,
        data: {projectId},
      });
    }
  }, [projectId, setServicesQueryData]);

  const {setQueryData: setQuotaLimitsQueryData} = useDashboardApi<{
    projectId: string;
  }>();
  useEffect(() => {
    if (projectId) {
      setQuotaLimitsQueryData({
        action: getProjectQuotaLimits,
        data: {projectId},
      });
    }
  }, [projectId, setQuotaLimitsQueryData]);

  const {setQueryData: setQuotaUtilizationData} = useDashboardApi<{
    organizationId: string;
  }>();
  useEffect(() => {
    if (organizationId) {
      setQuotaUtilizationData({
        action: getOrganizationQuotaUtilization,
        data: {organizationId},
      });
    }
  }, [organizationId, setQuotaUtilizationData]);

  return <Outlet />;
}

export default ProjectWrapper;
